
export const background_color = '#1408bd'
export const primaryColor ="#183559"